import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import logimg from "../images/login_img.png";
import { FaEnvelope, FaLock } from "react-icons/fa";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    try {
      const res = await api.post("/users/login", {
        email,
        password,
      });

      localStorage.setItem("user", JSON.stringify(res.data));

      navigate("/dashboard");
    } catch (err) {
      alert("Invalid login");
    }
  };

  return (
    <div className="h-screen flex">
      <div className="flex items-center justify-center w-full lg:w-1/2 bg-gray-100 px-4 lg:px-0">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-[410px]">
          <h2 className="text-3xl font-bold mb-6 text-center text-[#0b0675]">
            CRM Login
          </h2>

          <div className="relative mb-4">
            <FaEnvelope className="absolute left-3 top-4 text-gray-500" />

            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-gray-400 w-full p-2.5 pl-10 rounded focus:outline-none"
            />
          </div>

          <div className="relative mb-3">
            <FaLock className="absolute left-3 top-4 text-gray-500" />

            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border border-gray-400 w-full p-2.5 focus:outline-none pl-10 rounded mb-3"
            />
          </div>

          <button
            onClick={login}
            className="bg-[#0e0469] text-white w-full p-2.5 text-xl rounded-lg font-semibold transition"
          >
            Login
          </button>
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/2">
        <img src={logimg} alt="CRM" className="w-full h-full object-cover" />
      </div>

      <footer className="absolute bottom-0 left-0 w-full text-center text-md text-gray-900 bg-white py-2 px-4">
        Copyright © {new Date().getFullYear()}{" "}
        <a
          href="https://aksharconsultancy.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-800 font-semibold hover:underline"
        >
          Akshar Consultancy Services Pvt. Ltd.
        </a>{" "}
        All rights reserved
      </footer>
    </div>
  );
}
